<template>
  <a :href="siteDir" class="blog-go-to-site">
    <svg class="blog-go-to-site__icon"><use xlink:href="#svg-blog-package"></use></svg>
    {{ messages.toShop }}
  </a>
</template>

<script lang="ts" setup>
import { useResultsStore } from '@/storePinia/stores/results';
import { computed } from 'vue';

const resultsStore = useResultsStore();

const messages = computed(() => resultsStore?.messages);
const siteDir = computed(() => resultsStore?.siteLanguages?.siteDir);
</script>

<style lang="scss" scoped>
.blog-go-to-site {
  display: flex;
  align-items: center;
  justify-content: center;
  grid-area: goto;
  font-weight: 600;
  font-size: rem(12);
  line-height: 100%;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  height: 40px;
  background: #f5e6d8;
  padding: 0 14px;
  white-space: nowrap;
  @include point-md {
    height: 32px;
    align-self: flex-end;
  }
  &__icon {
    display: block;
    width: 16px;
    height: 16px;
    margin-right: 10px;
    fill: var(--background-black);
  }
}
</style>
